import React from 'react';
import styled from 'styled-components';

import useDispensary from 'src/dispensary/hooks/use-dispensary';
import { DialogHeading } from 'src/components/modals/components/simple-dialog';
import { Button, TextButton } from 'src/components/core';
import { getTermsOfUse } from 'src/components/loyalty/loyalty.helpers';
import useErnie from 'shared/hooks/use-ernie';
import { ERNIE_TYPES } from 'shared/constants';
import { isReferralsRoute as isReferralsRouteUtils } from 'src/components/loyalty/rewards/dpos-utils';
import { useRouter } from 'next/compat/router';

type TermsProps = {
  onClose: () => void;
  programName: string;
  createUserAndPin: () => void;
};

export const Terms = ({ onClose, programName, createUserAndPin }: TermsProps): JSX.Element => {
  const showErnie = useErnie();
  const { dispensary } = useDispensary();
  const router = useRouter();
  const isReferralsRoute = router ? isReferralsRouteUtils(router) : false;

  const handleOnClose = (): void => {
    if (isReferralsRoute) {
      showErnie(
        'You must be a loyalty member to be eligible for the referrals reward. Refresh the page to try again.',
        ERNIE_TYPES.DANGER
      );
    }
    onClose();
  };

  return (
    <>
      <StyledHeading fontSize={20}>Terms of Use</StyledHeading>

      <Content>{getTermsOfUse(dispensary.name, programName, dispensary.location?.state)}</Content>

      <Button onClick={createUserAndPin} mb={16} width='264px'>
        Agree & Continue
      </Button>

      <StyledTextButton onClick={handleOnClose}>Cancel</StyledTextButton>
    </>
  );
};

const StyledHeading = styled(DialogHeading)`
  margin-bottom: 24px;
`;

const Content = styled.p`
  color: var(--dcm-modal-secondary-text-color, #646d72);
  margin-bottom: 32px;
`;

const StyledTextButton = styled(TextButton)`
  font-weight: 600;
`;
